import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocReportsUnsubscribeRoute: InvariantJiraRoute = {
	name: 'eoc-reports-unsubscribe',
	path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
	exact: true,
};
